<template>
  <div>
    <v-card class="table elevation-0">
      <v-data-table
        v-model="tableValue"
        :headers="tableHeaders"
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        :rows-per-page-text="isDesktop ? 'Rows per page:' : ''"
        item-key="id"
      >
        <template slot="items" slot-scope="props">
          <tr
            :class="{
              clickable: itemClickable,
            }"
            @click="$emit('item-click', props.item)"
          >
            <td v-for="header in headers" :key="header.name">
              <div v-if="header.value">
                <span class="data-table-text">{{ props.item[header.value] }}</span>
              </div>
              <div v-else>
                <v-icon small @click.stop="$emit('delete', props.item.id)">
                  delete
                </v-icon>
              </div>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          {{ missingDataLabel }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'data-table',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    itemClickable: {
      type: Boolean,
      default: () => false,
    },
    rowsPerPageItems: {
      type: Array,
      default: () => [5, 10, 25, 100],
    },
    missingDataLabel: {
      type: String,
      default: () => '',
    },
    withActions: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    const headers = this.headers
    const actionHeader = {
      text: 'Actions',
      align: 'left',
      sortable: false,
      value: null,
    }
    if (this.withActions) {
      headers.push(actionHeader)
    }

    return {
      tableValue: [],
      tableHeaders: headers,
      isDesktop: false,
    }
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
    if (window.innerWidth > 800) {
      this.isDesktop = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler() {
      if (window.innerWidth > 800) {
        this.isDesktop = true
      } else {
        this.isDesktop = false
      }
    },
  },
}
</script>

<style>
.table {
  border: 2px solid #f5f5f5;
  border-radius: 8px;
}

thead tr {
  background-color: #f5f5f5;
  height: 40px !important;
  border-radius: 8px 8px 0 0;
  border-bottom: none !important;
}

thead tr th {
  font-family: 'Raleway', sans-serif;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 1.43 !important;
  color: #666666 !important;
}

tbody tr {
  border-bottom: none !important;
}

tbody tr:hover {
  background: rgba(2, 119, 189, 0.1) !important;
}

.data-table-text {
  font-size: 16px !important;
}

.v-datatable__actions {
  border-top: 2px solid #f5f5f5 !important;
  background: none !important;
  height: 40px;
  flex-wrap: nowrap !important;
}

.v-datatable__actions__select {
  width: 40px;
}

.v-datatable {
  height: 40px;
}

.v-datatable .theme--light.v-text-field:not(.v-input--has-state) .v-input__slot::before,
.v-datatable .theme--light.v-text-field:not(.v-input--has-state) .v-input__slot:hover::before,
.v-datatable
  .theme--light.v-text-field.v-input--is-focused:not(.v-input--has-state)
  .v-input__slot::before {
  border-color: transparent !important;
}
</style>
